
const m = window.require("discourse/components/modal/ignore-duration-with-username");
if (m.default && !m.__esModule) {
  m.__esModule = true;
}
module.exports = m;
